//Document ready
$(function() {
	matchHeightBulk();
});

//Resize
$(window).resize(function() {});

//Functions

//Match height bulk
function matchHeightBulk() {}
